module.exports = __webpack_public_path__ + "static/media/blueok-small.e394d3b9.svg";